<template>
  <div class="" style="width: 100%;">
   <v-row>
    <v-col>
    <v-container fluid>
      <v-row>
        <v-col class='col-md-4 d-flex flex-column justify-start'>
          <div class="d-flex flex-row align-center mb-2">
            <v-btn fab x-small @click="()=>$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h2 class="mx-1" style="color: maroon;">Return #{{$route.params.id}}</h2>
            <span>
              <span v-if="dreturn.status===-1" class="v-btn warning pa-1" style="font-size: 10px">{{parseStatus(dreturn.status)}}</span>
              <span v-if="dreturn.status===0" class="v-btn orange pa-1" style="font-size: 10px">{{parseStatus(dreturn.status)}}</span>
              <span v-if="dreturn.status===1" class="v-btn success pa-1" style="font-size: 10px">{{parseStatus(dreturn.status)}}</span>
              <span v-if="dreturn.status===2" class="v-btn success pa-1" style="font-size: 10px">{{parseStatus(dreturn.status)}}</span>
              <span v-if="dreturn.status===3" class="v-btn success pa-1" style="font-size: 10px">{{parseStatus(dreturn.status)}}</span>
            </span>
            <v-progress-circular
              indeterminate
              color="green"
              v-if="initialLoader"
            ></v-progress-circular>
            <v-icon v-if="updateStateValue===0" class="ml-2" color="warning">mdi-cloud-refresh</v-icon>
            <v-icon v-if="updateStateValue===1" class="ml-2" color="success">mdi-cloud-check</v-icon>
            <v-icon v-if="updateStateValue===2" class="ml-2" color="error">mdi-cloud-alert</v-icon>
            <DocumentHistoryDialog class="ml-3" :url="`/api/returns/history/${$route.params.id}`" title="Return" />
          </div>
          <div v-if="!initialLoader" outlined class="d-flex flex-column">
            <v-card outlined>
              <v-card-text class="d-flex flex-column">
              <span>Created By: {{lookupUsername(dreturn.createdBy)}}</span>
              <span>Created At: {{utils.formatDate(dreturn.createdAt)}} at {{utils.formatTime(dreturn.createdAt)}}</span>
              <span>Sealed By: {{lookupUsername(dreturn.sealedBy)}}</span>
              <span>Sealed At: {{utils.formatDate(dreturn.sealedAt)}} at {{utils.formatTime(dreturn.sealedAt)}}</span>
              </v-card-text>
            </v-card>
            <v-card outlined>
              <v-card-text>
                <confirmedActionButton
                  dense
                  small
                  color="info"
                  buttonText="Seal"
                  requireUsername
                  requirePassword
                  :loading="sealLoader"
                  @cb="attemptSeal"
                  :disabled="!returnOk()"
                  :dialogText="'Please ensure all fields are correct. Your identity will be linked to this document. Enter your username and password to confirm.'"
                />
                <confirmedActionButton
                  v-if="isAllowed('return', 'void') && dreturn.status !== -1"
                  class="mx-2"
                  color="warning"
                  small
                  buttonText="Void"
                  requireUsername
                  requirePassword
                  requireReason
                  :loading="voidLoader"
                  @cb="voidReturn"
                  fabIcon="mdi-close"
                  :disabled="voidLoader || initialLoader"
                  :dialogText="dreturn.status === 1 ? 'Voiding takes the returned stock back out of inventory and voids the credit note, which is only possible while it is unredeemed. Enter your credentials and a reason.' : 'Enter your credentials and a reason to void this return.'"
                />
                <confirmedActionButton
                  v-if="isAllowed('return', 'unvoid') && dreturn.status === -1"
                  class="mx-2 white--text"
                  color="teal"
                  small
                  buttonText="Unvoid"
                  requireUsername
                  requirePassword
                  requireReason
                  :loading="voidLoader"
                  @cb="unvoidReturn"
                  fabIcon="mdi-undo"
                  :disabled="voidLoader || initialLoader"
                  dialogText="Unvoiding puts this return back as it was before it was voided: the stock goes back in and the credit note is reinstated. Enter your Super Admin credentials and a reason."
                />
                <!-- <v-btn v-if="isAllowed('return', 'c')" :disabled="invoice.status<1" class="mr-2 white--text" dense color="teal" small @click="attemptCreateReturn">Make Return</v-btn> -->
              </v-card-text>
            </v-card>
            <div v-if="getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_RETURNS')" style="width: 100%;">
              <dynamicButtonContainer :containerId="`${getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_RETURNS')}`" :data="{status: dreturn.status, id1: $route.params.id}" style="width: 100%;"/>
            </div>
          </div>
          <div class="d-flex flex-column mt-4">
            <!-- <v-text-field :disabled="modifyDisabledCriteria" @change="directSearchOrder" dense outlined v-model="directOrderSearch.value" min="0" :loading="directOrderSearch.loading" type="number" clearable label="Order ID"></v-text-field>   -->
            <v-card outlined class="mb-3 returnOrderCard">
              <div class="d-flex flex-row flex-wrap align-center justify-space-between px-3 pt-2" style="gap: 6px;">
                <span class="d-flex flex-row align-center" style="gap: 6px;">
                  <v-btn small text outlined :to="`/orders/view/${this.dreturn.orderId}`">Order #{{this.dreturn.orderId|| "-"}}</v-btn>
                </span>
                <span v-if="selectedOrder.Customer" class="d-flex flex-row align-center" style="gap: 8px;">
                  <v-btn :to="`/customers/view/${selectedOrder.Customer.id}`" fab x-small color="warning" style="height: 28px; width: 28px;" title="View customer"><v-icon small>mdi-account-eye-outline</v-icon></v-btn>
                  <span class="text-right" style="line-height: 1.25;">
                    <div class="grey--text text--darken-1" style="font-size: 12px;">Customer</div>
                    <div class="font-weight-bold" style="font-size: 16px;">{{selectedOrder.Customer.name}}</div>
                    <div v-if="selectedOrder.Customer.phone" style="font-size: 13px;">Phone: <b>{{selectedOrder.Customer.phone}}</b></div>
                  </span>
                </span>
              </div>
              <div class="px-3 pt-1 pb-2" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 6px 10px; text-align: left;">
                <div v-if="selectedOrder?.metadata" class="returnTile returnTileBig"><div class="returnTileLabel">Grand Total</div><div class="returnTileValue"><b>{{helpers.formatCurrency(selectedOrder.metadata.grandTotal)}}</b></div></div>
                <div class="returnTile returnTileBig"><div class="returnTileLabel">Total Discounts</div><div class="returnTileValue"><b>{{helpers.formatCurrency(selectedOrder.discountAmount)}}</b></div></div>
                <div class="returnTile returnTileBig"><div class="returnTileLabel">Total Paid</div><div class="returnTileValue"><b>{{helpers.formatCurrency(selectedOrder.totalPaid || 0)}}</b></div></div>
                <div v-if="selectedOrder.sealedReturnsCount > 0" class="returnTile returnTileBig"><div class="returnTileLabel">Total Value Returned</div><div class="returnTileValue"><b>{{helpers.formatCurrency(selectedOrder.totalReturned || 0)}}</b></div></div>
              </div>
              <v-card-text class="pt-0 pb-2">
                <span v-if="selectedOrder">
                  <div v-for="item in selectedOrder.OrderLineItems" :key="item.id" class="returnOrderLine" style="padding: 8px 10px; margin-top: 8px; border-radius: 7px;">
                    <div class="d-flex flex-row justify-space-between align-start" style="gap: 8px;">
                      <div style="text-align: left;">
                        <div class="font-weight-bold" style="font-size: 15px; line-height: 1.25;">{{item.productName}}</div>
                        <div style="font-size: 13px; line-height: 1.6;">
                          <router-link v-if="isAllowed('product', 'u')" :to="'/products/view/'+item.productId">PL-{{item.productId}}</router-link><span v-else>PL-{{item.productId}}</span>
                          <span class="ml-3">SKU: <b>{{item.sku || '-'}}</b></span>
                        </div>
                      </div>
                      <span class="d-flex flex-row flex-shrink-0" style="gap: 6px;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              <v-btn x-small :disabled="addRemainingDisabled(item)" :loading="item.loading" fab color="info" @click="addReturnLineItem(item, true)"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </span>
                          </template>
                          <span>{{addRemainingTooltip(item)}}</span>
                        </v-tooltip>
                        <v-btn x-small :disabled="addReturnLineItemDisabled(item)" :loading="item.loading" fab color="success" title="Add" @click="addReturnLineItem(item)"><v-icon>mdi-plus</v-icon></v-btn>
                      </span>
                    </div>
                    <div class="mt-1" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(165px, 1fr)); gap: 6px 10px; text-align: left;">
                      <div class="returnTile"><div class="returnTileLabel">Unit Sold For</div><div class="returnTileValue"><b>{{utils.formatCurrency(item.metadata.lineTotal/item.quantity)}}</b></div></div>
                      <div class="returnTile"><div class="returnTileLabel">QTY Purchased</div><div class="returnTileValue"><qty-text :parts="qtyParts(item, item.quantity)"/></div></div>
                      <div v-if="selectedOrder.deliveryInfo && selectedOrder.deliveryInfo.deliveryType==='delivery'" class="returnTile"><div class="returnTileLabel">QTY Already Delivered</div><div class="returnTileValue"><qty-text :parts="qtyParts(item, item.deliveredQty|| 0)"/></div></div>
                      <div class="returnTile"><div class="returnTileLabel">QTY Already Returned</div><div class="returnTileValue"><qty-text :parts="qtyParts(item, item.returnedQt|| 0)"/></div></div>
                      <div class="returnTile"><div class="returnTileLabel">QTY Remaining</div><div class="returnTileValue"><qty-text :parts="qtyParts(item, remainingBalance(item))"/></div></div>
                    </div>
                  </div>
                </span>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
        <v-col class="col-md-8 d-flex flex-column">
          <v-card v-if="dreturn.CreditNote" class="mb-2" outlined>
            <v-card-title class="d-flex flex-row flex-wrap align-center justify-space-between pb-2" style="gap: 8px;">
              <h3>Credit Note # {{ dreturn.CreditNote.id }}</h3>
              <v-chip small label dark :color="{'-1': 'warning', '0': 'orange', '1': 'info', '2': 'success'}[String(dreturn.CreditNote.status)] || 'grey'" style="font-weight: bold;">{{utils.parseCNStatus(dreturn.CreditNote.status)}}</v-chip>
            </v-card-title>
            <v-card-text class="pt-0 pb-2">
              <div class="d-flex flex-row flex-wrap" style="gap: 8px 10px; text-align: left;">
                <div class="returnTile returnTileBig returnTileNoWrap" style="min-width: 150px;"><div class="returnTileLabel">Amount</div><div class="returnTileValue"><b>{{utils.formatCurrency(dreturn.CreditNote.amount)}}</b></div></div>
                <div class="returnTile returnTileBig returnTileNoWrap" style="min-width: 150px;"><div class="returnTileLabel">Created At</div><div class="returnTileValue"><b>{{utils.formatDate(dreturn.CreditNote.createdAt, 'withTime')}}</b></div></div>
                <div class="returnTile returnTileBig returnTileNoWrap" style="min-width: 150px;"><div class="returnTileLabel">Issued By</div><div class="returnTileValue"><b>{{lookupUsername(dreturn.CreditNote.issuedBy) || '-'}}</b></div></div>
                <div class="returnTile returnTileBig returnTileNoWrap" style="min-width: 150px;"><div class="returnTileLabel">Expires At</div><div class="returnTileValue"><b>{{utils.formatDate(dreturn.CreditNote.expiresAt)}}</b></div></div>
                <div class="returnTile returnTileBig" style="flex: 1 1 100%;"><div class="returnTileLabel">Notes</div><div class="returnTileValue"><b>{{dreturn.CreditNote.notes||'-'}}</b></div></div>
              </div>
            </v-card-text>
            <v-card-actions>
              <span v-if="getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_RETURN_CREDIT_NOTE')">
                <dynamicButtonContainer :containerId="`${getGlobalValue('VEC_PRINT_SYSTEM_CONTAINER_RETURN_CREDIT_NOTE')}`" :data="{id1: dreturn.CreditNote.id}"/>
              </span>
              <confirmedActionButton
                class="mx-2" 
                color="warning" 
                small
                text  
                buttonText="Redeem For Cash"
                requireUsername
                requirePassword
                :loading="cnRedeemLoader"
                @cb="redeemCNForCash"
                fabIcon="mdi-close"
                :disabled="dreturn.CreditNote.status != 1"
                :dialogText="'Redeeming a CN for cash cannot be undone. Are you sure you wish to proceed?'"
                />
            </v-card-actions>
          </v-card>
          <span class="mb-2">
            <h3 v-if="dreturn.status && dreturn.status==0">This will create a CN for {{utils.formatCurrency(dreturn.totalValue)}}</h3>
            <!-- <span class="d-flex flex-row">
              <h3 style="color: green;">This return created a CN for {{utils.formatCurrency(dreturn.totalValue)}}</h3>
              <v-btn v-if="selectedOrder" class="ml-2" color="info" fab x-small @click="()=>$router.push({path: `/customers/view/${selectedOrder.Customer.id}`})">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </span> -->
          </span>
          <v-card outlined>
            <v-card-title class="d-flex flex-row flex-wrap justify-space-between" style="gap: 8px;">
              <h3>Returned Items ({{utils.pff(dreturn.ReturnLineItems?dreturn.ReturnLineItems.reduce((acc,x)=>acc+utils.pff(x.quantity),0):0) || '-'}} units)</h3>
              <span class="d-flex flex-column">
                <span class="d-flex flex-row">
                  <h4>Total Estimated Credit to Customer: {{utils.formatCurrency(this.computedSubtotal || 0)}}</h4>
                </span>
                <span class="d-flex flex-row flex-wrap align-center" style="gap: 4px;">
                  <h4 style="white-space: nowrap;">Value of Credit Note: $</h4>
                  <v-text-field :disabled="modifyDisabledCriteria" type="number" @change="updateReturn(true)" outlined v-model="dreturn.totalValue" dense hide-details style="max-width: 140px;"/>
                </span>
              </span>
            </v-card-title>
            <v-card-text>
              <div v-for="item in dreturn.ReturnLineItems" :key="item.id">
                <div class="d-flex flex-column justify-space-between returnLine" style="align-text: left; padding: 8px 10px; margin-top: 6px; border-radius: 7px;">
                  <span class="d-flex flex-row justify-space-between align-center">
                    <span class="font-weight-bold" style="font-size: 15px; text-align: left;">{{item.Product.name}} <span class="font-weight-regular ml-2" style="font-size: 13px;">ID: {{item.productId}}</span><span class="font-weight-regular ml-2" style="font-size: 13px;">SKU: <b>{{item.Product.sku || (sourceOrderLine(item) && sourceOrderLine(item).sku) || '-'}}</b></span></span>
                    <span class="d-flex flex-row justify-space-between align-center">
                      <span class="d-flex flex-row" v-if="!isMultiples(item) && countLineItemsForProduct(item.productId)<=1">
                        <v-badge v-if="!item.Product?.metadata?.allowFractional && item.Product?.metadata?.requireSerials && (utils.pff(item.quantity)-item.serials?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(item.quantity)-(item.serials?.length))!==0?utils.pff(item.quantity)-(item.serials?.length):''}`">
                          <v-btn class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                        </v-badge>
                        <v-badge v-else-if="!item.Product?.metadata?.allowFractional && (utils.pff(item.quantity)-item.serials?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(item.quantity)<item.serials?.length?'error':'success'" :content="`${(utils.pff(item.quantity)-(item.serials?.length))!==0?utils.pff(item.quantity)-(item.serials?.length):''}`">
                          <v-btn class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                        </v-badge>
                        <v-btn color="success" v-else-if="!item.Product?.metadata?.allowFractional" class="ml-1 mb-1" @click="openLineItemSerialsDialog(item)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>
                      </span>
                    </span>
                  </span>
                  <span class="d-flex flex-row flex-wrap align-start mt-1" style="gap: 8px 12px;">
                    <span class="d-flex flex-row flex-wrap align-start" style="gap: 8px 12px;">
                      <div v-if="item.metadata?.quantities?.length>0 && isMultiples(item)">
                        <table class="multiplesLocTable">
                          <tbody>
                            <tr v-for="(loc, index) in item.metadata.quantities" :key="index">
                              <td>
                                <span class="d-flex flex-row align-center">
                                  <v-text-field :disabled="modifyDisabledCriteria" type="number" step="1" min="0" dense v-model="loc.qtyOfMultiple" @change="updateReturnLineItem(item)" :label="(lookupBranch(loc.locationId)||'Deleted Location')+' QTY'" style="min-height: 10px; font-weight: bold; font-size: 12px; padding: 0px; padding-top: 5px; width: 80px; margin-bottom: -27px;" outlined/>
                                  <span class="ml-2" style="font-size: 12px;">= {{utils.pff(loc.quantity)}}</span>
                                </span>
                              </td>
                              <td v-if="index===0" :rowspan="item.metadata.quantities.length" class="multiplesLocTableMerged">
                                <span class="d-flex flex-row align-center">
                                  <span class="mr-1">×</span>
                                  <v-text-field :disabled="modifyDisabledCriteria || item.metadata.lockMultipleAmount!==false" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" min="0" dense v-model="item.metadata.multipleAmount" @change="updateReturnLineItem(item)" :label="multipleLabel(item)" style="min-height: 10px; font-weight: bold; font-size: 12px; padding: 0px; padding-top: 5px; width: 80px; margin-bottom: -27px;" outlined/>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div style="font-size: 13px; line-height: 1.3;" class="mt-1">Total: <qty-text :parts="returnLineParts(item)"/></div>
                      </div>
                      <div v-else-if="item.metadata?.quantities?.length>0">
                        <span v-for="(loc, index) in item.metadata.quantities" :key="index" class="d-flex flex-row align-center">
                          <v-text-field :disabled="modifyDisabledCriteria" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" :min="utils.pff(item.metadata.quantityStepAmount||1)" dense v-model="loc.quantity" @change="updateReturnLineItem(item)" :label="lookupBranch(loc.locationId)||'Deleted Location'" :max="item.max" style="min-height: 10px; font-weight: bold; font-size: 12px; padding: 0px; padding-top: 5px; width: 100px; margin-bottom: -27px;" outlined/>
                          <span class="mr-2">
                            <v-badge v-if="!item.Product.metadata?.allowFractional && item.Product.metadata?.requireSerials && (utils.pff(loc.quantity)-item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap bottom color="error" :content="`${(utils.pff(loc.quantity)-(item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length))!==0?utils.pff(loc.quantity)-(item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length):''}`">
                              <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                            </v-badge>
                            <v-badge v-else-if="!item.Product.metadata?.allowFractional && (utils.pff(loc.quantity)-item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length)!==0" offset-x="15" offset-y="15" overlap :color="utils.pff(loc.quantity)<item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length?'error':'success'" :content="`${(utils.pff(loc.quantity)-(item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length))!==0?utils.pff(loc.quantity)-(item.serials?.filter(x => x.ReturnSerialJoin.metadata.locationId===loc.locationId)?.length):''}`">
                              <v-btn :disabled="loader" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                            </v-badge>
                            <v-btn :disabled="loader" color="success" v-else-if="!item.Product.metadata?.allowFractional" class="ml-1 mb-1" @click="openWarehouseLineItemSerialsDialog(item, loc)" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>
                            <span v-else-if="item.Product.metadata?.allowFractional">Item does not support {{serialNaming.pluralLower}}.</span>
                          </span>
                        </span>
                        <div style="font-size: 13px; line-height: 1.3;" class="mt-1">Total: <qty-text :parts="returnLineParts(item)"/></div>
                      </div>
                      <div v-else-if="isMultiples(item)">
                        <div class="d-flex flex-row align-center">
                          <v-text-field label="QTY" :disabled="modifyDisabledCriteria" type="number" step="1" min="0" dense hide-details v-model="item.metadata.qtyOfMultiple" @change="updateReturnLineItem(item)" style="width: 80px;" outlined/>
                          <span class="mx-1">×</span>
                          <v-text-field :label="multipleLabel(item)" :disabled="modifyDisabledCriteria || item.metadata.lockMultipleAmount!==false" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" min="0" dense hide-details v-model="item.metadata.multipleAmount" @change="updateReturnLineItem(item)" style="width: 80px;" outlined/>
                        </div>
                        <div style="font-size: 13px; line-height: 1.3;" class="mt-1">Total: <qty-text :parts="returnLineParts(item)"/></div>
                      </div>
                      <div v-else>
                        <v-text-field label="QTY" :disabled="modifyDisabledCriteria" type="number" :step="utils.pff(item.metadata?.quantityStepAmount||1)" :min="utils.pff(item.metadata.quantityStepAmount||1)" dense hide-details v-model="item.quantity" @change="updateReturnLineItem(item)" :max="item.max" style="width: 100px;" outlined/>
                      </div>

                      <v-text-field :disabled="modifyDisabledCriteria" @change="updateReturnLineItem(item)" dense outlined hide-details v-model="item.returnValue" type="number" label="Value" style="width: 110px;"></v-text-field>
                      <div style="font-size: 14px; align-self: center; white-space: nowrap;">Line Total: <b>{{utils.formatCurrency(utils.pff2(utils.pff(item.quantity, item.metadata?.conversion ? 12 : undefined)*item.returnValue))}}</b></div>
                    </span>
                    <v-textarea :disabled="modifyDisabledCriteria" @change="updateReturnLineItem(item)" outlined hide-details no-resize rows="2" row-height="20" label="Notes" v-model="item.notes" style="flex: 1 1 260px; min-width: 220px;"></v-textarea>
                    <v-btn class="ml-auto" x-small :disabled="modifyDisabledCriteria" fab color="error" title="Remove" @click="removeReturnLineItem(item.id)"><v-icon>mdi-close</v-icon></v-btn>
                  </span>
                  <div v-if="overReturn(item)" class="d-flex flex-row align-center mt-1 warning--text" style="font-size: 13px; gap: 4px;">
                    <v-icon x-small color="warning">mdi-alert</v-icon>
                    <span>More than was ordered: returning <qty-text :parts="returnLineParts(item)"/>, but only <qty-text :parts="qtyParts(sourceOrderLine(item), overReturn(item).balance)"/> is left to return (ordered <qty-text :parts="qtyParts(sourceOrderLine(item), sourceOrderLine(item).quantity)"/>, already returned <qty-text :parts="qtyParts(sourceOrderLine(item), sourceOrderLine(item).returnedQt || 0)"/>).</span>
                  </div>
                  <span class="d-flex flex-row align-center mt-1">
                    <!-- <v-checkbox :disabled="modifyDisabledCriteria" @change="updateReturnLineItem(item)" v-model="item.isReplacement" label="Replacement ? "></v-checkbox> -->
                    <v-checkbox :disabled="modifyDisabledCriteria" @change="updateReturnLineItem(item)" v-model="item.addedToInventory" class="mt-0 pt-0" dense hide-details label="Add back to inventory ?"></v-checkbox>
                  </span>
                </div>
              </div>
            </v-card-text>
            <v-card-text>
              <span v-if="getGlobalValue('productSerialShowOnReturn')" class="d-flex flex-row mt-3 justify-end">
                <span class="d-flex flex-column">
                  <h3>{{serialNaming.singular}} Legend</h3>
                  <span class="mt-2">
                    <v-badge offset-x="15" offset-y="15" overlap color="error" content="-1">
                      <v-btn class="ml-1 mb-1" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                    </v-badge>
                    <span class="ml-2">Has 1 too many non-required {{serialNaming.pluralLower}}.</span>
                  </span>
                  <span class="mt-2">
                    <v-badge offset-x="15" offset-y="15" overlap color="success" content="1">
                      <v-btn class="ml-1 mb-1" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                    </v-badge>
                    <span class="ml-2">Missing 1 non-required {{serialNaming.singularLower}}.</span>
                  </span>
                  <span class="mt-2">
                    <v-badge offset-x="15" offset-y="15" overlap bottom color="error" :content="1">
                      <v-btn class="ml-1 mb-1" x-small fab color="warning"><v-icon>mdi-barcode</v-icon></v-btn>
                    </v-badge>
                    <span class="ml-2">Requires 1 more {{serialNaming.singularLower}}.</span>
                  </span>
                  <span class="mt-2">
                    <v-btn color="success" class="ml-1 mb-1" x-small fab><v-icon>mdi-barcode</v-icon></v-btn>
                    <span class="ml-2">Has all {{serialNaming.pluralLower}}.</span>
                  </span>
                </span>
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
      </v-col>
     </v-row>

    <v-dialog scrollable v-model="searchCustomerDialog.isOpen" width="500">
      <v-card>
        <v-card-title class="text-h5">
          Search Customer
        </v-card-title>
        <v-card-text style="padding-top: 20px;">
          <v-text-field :loading="searchCustomerDialog.loader" ref="customerDialogPhone" v-model="customer.phone" @keyup="findCustomerByPhone" label="Phone" outlined></v-text-field>
          <v-chip style="margin-bottom: 20px; margin-right: 5px;" v-for="suggestion in customer.suggestedMatches" :key="suggestion.id" @click="setCustomerAndClose(suggestion)">
            <span>{{suggestion.name}} - {{suggestion.phone}}</span>
          </v-chip>
          <v-text-field :loading="findCustomerByNameLoader" ref="customerDialogName" v-model="customer.name" @keyup="findCustomerByName" label="Name" outlined></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="error" text @click="closeSearchCustomerDialog">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="confirmRedeemDialog.isOpen"
        width="600"
    >
      <v-card>
        <v-card-title>
          Confirm Register Bypass
        </v-card-title>
        <v-card-text>
          <span>You currently don't have a register opened at the moment. Are you sure you want to continue with redeeming for cash before opening a register?</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancelRedeemConfirm">Close</v-btn>
          <v-btn color="success" @click="confirmRedeem">Redeem For Cash Without a Register</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="lineItemSerialsDialog.isOpen" width="1000">
      <v-card>
        <v-card-title v-if="lineItemSerialsDialog.data">
          {{serialNaming.plural}} for Product {{lineItemSerialsDialog.data.productId}}
        </v-card-title>
        <v-card-text v-if="lineItemSerialsDialog.data">
          <v-row>
            <v-col v-if="dreturn.status!==-1 && dreturn.status===0 && !lineItemSerialsDialog.data.metadata.quantities" cols="4" style="border-right: 1px solid #eee" class="d-flex flex-column">
              <h3>Add {{serialNaming.singular}}</h3>
              <span class="d-flex flex-row justify-space-between align-center">
                <v-text-field clearable @keydown.enter="addLineItemSerial" :loading="lineItemSerialsDialog.isLoading" v-model="lineItemSerialsDialog.newSerial" outlined hide-details dense :label="`${serialNaming.singular}`"/>
                <v-btn :disabled="(lineItemSerialsDialog.data.serials?.length>=utils.pff(lineItemSerialsDialog.data.quantity))||!lineItemSerialsDialog.newSerial" :loading="lineItemSerialsDialog.isLoading" @click="addLineItemSerial" class="ml-2" color="success" fab x-small><v-icon>mdi-plus</v-icon></v-btn>
              </span>
              <span v-if="lineItemSerialsDialog.data.Product?.metadata?.requireSerials" class="red--text">This product requires all {{serialNaming.pluralLower}} to be entered.</span>
              <span v-if="lineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">All {{serialNaming.pluralLower}} must be unique from all other products and itself.</span>
              <span v-if="!lineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">This product does not have {{serialNaming.pluralLower}} required but must still be unique if they're included.</span>
            </v-col>
            <v-col>
              <h3>{{serialNaming.plural}} ({{lineItemSerialsDialog.data.serials?.length||0}}/{{utils.pff(lineItemSerialsDialog.data.quantity)}})</h3>
              <v-text-field :disabled="lineItemSerialsDialog.data.serials.length===0" :hint="lineItemSerialsDialog.data.serials.length===0?'No items in list.':''" :persistent-hint="lineItemSerialsDialog.data.serials.length===0" dense outlined label="Search List" v-model="lineItemSerialsDialog.search" clearable @input="filterLineItemSerials"/>
              <span class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
                <span v-for="(warehouse, w) of warehouses" :key="w">
                  <h3 :class="`${(lineItemSerialsDialog.filtered.filter(x => (x.ReturnSerialJoin?.metadata?.locationId===warehouse.id))?.length||0)>(lineItemSerialsDialog.data.metadata.quantities?lineItemSerialsDialog.data.metadata.quantities.find(x => (x.locationId===warehouse.id))?.quantity:lineItemSerialsDialog.data.quantity)?'error--text':''}`">{{lookupBranch(warehouse.id)}} ({{lineItemSerialsDialog.filtered.filter(x => (x.ReturnSerialJoin?.metadata?.locationId===warehouse.id))?.length||0}}/{{lineItemSerialsDialog.data.metadata.quantities?lineItemSerialsDialog.data.metadata.quantities.find(x => (x.locationId===warehouse.id))?.quantity:lineItemSerialsDialog.data.quantity}})</h3>
                  <span v-if="lineItemSerialsDialog.filtered.filter(x => (x.ReturnSerialJoin?.metadata?.locationId===warehouse.id)).length>0">
                    <v-card class="mb-2" outlined v-for="(serial, i) of lineItemSerialsDialog.filtered.filter(x => (x.ReturnSerialJoin?.metadata?.locationId===warehouse.id))" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}}</b>
                        <span class="d-flex flex-row">
                          <v-btn v-if="dreturn.status!==-1 && dreturn.status===0" :disabled="lineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, lineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                          <v-btn v-if="dreturn.status!==0" class="ml-2" @click="$router.push({path: '/products/serial/'+serial.serial})" color="success" fab x-small><v-icon>mdi-history</v-icon></v-btn>
                        </span>
                      </span>
                    </v-card>
                  </span>
                  <span v-else>
                    <span>No matching serials entered for this location.</span>
                  </span>
                  <hr class="mb-2">
                </span>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeLineItemSerialsDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="warehouseLineItemSerialsDialog.isOpen" width="1000">
      <v-card>
        <v-card-title v-if="warehouseLineItemSerialsDialog.data">
          {{serialNaming.plural}} for {{warehouseLineItemSerialsDialog.data.productName}} (ID: {{warehouseLineItemSerialsDialog.data.productId}}) from {{lookupBranch(warehouseLineItemSerialsDialog.location)}}
        </v-card-title>
        <v-card-text v-if="warehouseLineItemSerialsDialog.data">
          <v-row>
            <v-col cols="4" style="border-right: 1px solid #eee" class="d-flex flex-column">
              <span class="d-flex flex-column">
                <h3>Add {{serialNaming.singular}}</h3>
                <span class="d-flex flex-row justify-space-between align-center">
                  <v-text-field @input="$forceUpdate()" clearable @keydown.enter="addWarehouseLineItemSerial" :loading="warehouseLineItemSerialsDialog.isLoading" v-model="warehouseLineItemSerialsDialog.newSerial" outlined hide-details dense :label="`${serialNaming.singular}`"/>
                  <v-btn :disabled="(warehouseLineItemSerialsDialog.data.serials?.length>=utils.pff(warehouseLineItemSerialsDialog.data.quantity))||!warehouseLineItemSerialsDialog.newSerial" :loading="warehouseLineItemSerialsDialog.isLoading" @click="addWarehouseLineItemSerial" class="ml-2" color="success" fab x-small><v-icon>mdi-plus</v-icon></v-btn>
                </span>
                <span v-if="warehouseLineItemSerialsDialog.data.Product?.metadata?.requireSerials" class="red--text">This product requires all {{serialNaming.pluralLower}} to be entered.</span>
                <span v-if="warehouseLineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">All {{serialNaming.pluralLower}} must be unique from all other products and itself.</span>
                <span v-if="!warehouseLineItemSerialsDialog.data.Product?.metadata?.requireSerials && getGlobalValue('replaceProductSerialsWithIMEI')">This product does not have {{serialNaming.pluralLower}} required but must still be unique if they're included.</span>
                <hr class="my-3">
              </span>
              <span>
                <h2>{{serialNaming.plural}} From Sale Order</h2>
                <span v-if="warehouseLineItemSerialsDialog.data.orderSerials.length>0">
                  <span v-if="dreturn.status===0">You can only add these by typing it in or scanning it.</span>
                  <div class="mt-2">
                    <v-card class="mb-2" outlined v-for="(serial, i) of warehouseLineItemSerialsDialog.data.orderSerials" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}}</b>
                        <v-btn x-small color="success" fab @click="addOrderSerial(serial, warehouseLineItemSerialsDialog, addWarehouseLineItemSerial)"><v-icon>mdi-plus</v-icon></v-btn>
                      </span>
                    </v-card>
                  </div>
                </span>
                <span v-else>
                  No {{serialNaming.pluralLower}} in this sale order.
                </span>
              </span>
            </v-col>
            <v-col>
              <h3>{{serialNaming.plural}} ({{warehouseLineItemSerialsDialog.data.serials?.length||0}}/{{utils.pff(warehouseLineItemSerialsDialog.data.metadata?.quantities?.find(x => x.locationId===warehouseLineItemSerialsDialog.location)?.quantity||0)}})</h3>
              <v-text-field :disabled="warehouseLineItemSerialsDialog.data.serials.length===0" :hint="warehouseLineItemSerialsDialog.data.serials.length===0?'No items in list.':''" :persistent-hint="warehouseLineItemSerialsDialog.data.serials.length===0" dense outlined label="Search List" v-model="warehouseLineItemSerialsDialog.search" clearable @input="filterWarehouseLineItemSerials"/>
              <span v-if="warehouseLineItemSerialsDialog.data.metadata.quantities" class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
                <span>
                  <h3>{{lookupBranch(warehouseLineItemSerialsDialog.location)}}</h3>
                  <span v-if="warehouseLineItemSerialsDialog.filtered.filter(x => x.ReturnSerialJoin?.metadata?.locationId===warehouseLineItemSerialsDialog.location).length>0">
                    <v-card class="mb-2" outlined v-for="(serial, i) of warehouseLineItemSerialsDialog.filtered.filter(x => x.ReturnSerialJoin?.metadata?.locationId===warehouseLineItemSerialsDialog.location)" :key="i">
                      <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                        <b>{{serial.serial}} (ID: {{serial.id}})</b>
                        <span class="d-flex flex-row">
                          <v-btn v-if="dreturn.status===0" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, warehouseLineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                        </span>
                      </span>
                    </v-card>
                  </span>
                  <span v-else>
                    <span>No matching serials entered for this location.</span>
                  </span>
                  <hr class="mb-2">
                </span>
              </span>
              <span v-else class="d-flex flex-column" style="max-height: 600px; overflow-y: auto;">
              <v-card class="mb-2" outlined v-for="(serial, i) of warehouseLineItemSerialsDialog.filtered" :key="i">
                <span class="pa-2 pl-5 d-flex flex-row align-center justify-space-between">
                  <b>{{serial.serial}}</b>
                  <span class="d-flex flex-row">
                    <v-btn v-if="dreturn.status===0" :disabled="warehouseLineItemSerialsDialog.isLoading" @click="removeLineItemSerial(serial.id, warehouseLineItemSerialsDialog)" color="error" fab x-small><v-icon>mdi-close</v-icon></v-btn>
                  </span>
                </span>
              </v-card>
            </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeWarehouseLineItemSerialsDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<style scoped>
.multiplesLocTable{
  border-collapse: collapse;
}
.multiplesLocTable td{
  padding: 2px 8px 2px 0;
  vertical-align: middle;
}
.multiplesLocTableMerged{
  padding-left: 8px !important;
  text-align: center;
}
.returnTile { background: rgba(255,255,255,0.7); border-radius: 5px; padding: 3px 8px; }
.returnTileLabel { font-size: 12px; opacity: 0.7; line-height: 1.3; }
.returnTileValue { font-size: 14px; line-height: 1.4; }
.returnTileBig .returnTileLabel { font-size: 13px; }
.returnTileBig .returnTileValue { font-size: 17px; }
.returnTileNoWrap .returnTileValue { white-space: nowrap; }
.returnOrderLine, .returnLine { background-color: rgba(0,0,0,0.05); }
/* dark mode: the light tints above would glare, so use light-on-dark tints instead */
.theme--dark .returnTile { background: rgba(255,255,255,0.08); }
.theme--dark .returnOrderLine, .theme--dark .returnLine { background-color: rgba(255,255,255,0.05); }
</style>
<script>
import axios from 'axios';
import {mapGetters, mapMutations} from 'vuex'
import utils from  '../../plugins/helpers'
import scanSystem from "../../plugins/scanSystem"
import dynamicButtonContainer from './../../components/dynamicButtonContainer.vue';
import confirmedActionButton from './../../components/confirmedActionButton.vue';
import DocumentHistoryDialog from './../../components/DocumentHistoryDialog.vue';
import _ from 'lodash';
import helpers from "../../plugins/helpers";
export default {
  components: {
    dynamicButtonContainer,
    confirmedActionButton,
    DocumentHistoryDialog,
    // prints a quantity with only the QTY count in bold: "87in [<b>3</b> x 2ft 5in]"
    QtyText: {
      props: {parts: {type: Object, required: true}},
      render(h){
        let pt = this.parts;
        return h('span', [pt.prefix || '', pt.count !== null && pt.count !== undefined ? h('b', pt.count) : '', pt.suffix || '']);
      }
    }

  },
  data () {
    return {
      utils: utils,
      loader: false,
      initialLoader: true,
      findCustomerByPhoneLoader: false,
      findCustomerByNameLoader: false,
      numUpdates: 0,
      printCNLoader: false,
      cnRedeemLoader: false,
      sealLoader: false,
      voidLoader: false,
      updateStateValue: 1, // 0 = updating; 1 = updateSuccess; 2 = updateFail
      locationLoading: false,
      printReturnLoader: false,
      singular: "Return",
      singularLower: "return",
      plural: "Returns",
      pluralLower: "returns",
      dreturn: {},
      searchCustomerDialog: {
        isOpen: false,
        term: '',
        results: [],
        loader: false,
      },   
      selectedCustomer: {},
      selectedOrder: {},
      purchaseTable: {
        headers: [
          {text: 'Order #', align: 'start', value: 'id'},
          { text: 'Date Created', value: 'createdAt' },
          { text: 'Grand Total', value: 'metadata.grandTotal' },
        ],
        items: []
      },
      adjuster: 0,
      customer: {},
      directOrderSearch: {
        value: '',
        loading: false
      },

      confirmRedeemLoading: false,
      confirmRedeemCredentials: null,
      confirmRedeemDialog: {
        isOpen: false,
      },

      warehouses: [],

      lineItemSerialsDialog: {
        isOpen: false,
        data: null,
        other: null,
        isLoading: false,
        newSerial: "",
        search: "",
        filtered: []
      },

      warehouseLineItemSerialsDialog: {
        isOpen: false,
        data: null,
        location: null,
        isLoading: false
      },
    }
  },
  created(){
    this.debouncedUpdateReturn = _.debounce(this.updateReturn, 500)
  },
  async mounted(){
    try{
      this.initialLoader = true;

      this.warehouses = this.getBranches;
      this.warehouses = this.warehouses.filter(x => x.id!==this.getBranch)
      this.warehouses = [{id: this.getBranch}].concat(this.warehouses);

      let arr = [];
      for(let warehouse of this.warehouses){
        let br = this.getBranchData(warehouse.id);
        if(!br?.metadata.removeFromQuantityFields){
          arr.push(warehouse);
        }
      }
      this.warehouses = arr;

      let res = await axios.get(`${this.getEndpoint}/api/returns/${this.$route.params.id}`)
      this.dreturn = res.data.data
      if(this.dreturn.Order){
        this.selectedOrder = this.dreturn.Order
        this.directOrderSearch.value = this.dreturn.orderId
        for(let i of this.selectedOrder.Returns){
          for(let j of i.ReturnLineItems){
            let q = (j.metadata?.orderLineItemId && this.selectedOrder.OrderLineItems.find(x=>x.id===j.metadata.orderLineItemId)) || this.selectedOrder.OrderLineItems.find(x=>x.productId==j.productId)
            if(!q) continue;
            if(!q.returnedQt) q.returnedQt = 0
            q.returnedQt += utils.pff(j.quantity)
          }
        }
      }

      this.selectedOrder?.OrderLineItems?.forEach(x=>x.loading = false)

      if(!this.dreturn.totalValue)
        this.dreturn.totalValue = parseFloat(this.computedSubtotal)
    
      if(!this.dreturn.addedToInventory)
        this.dreturn.addedToInventory = false

      //return has its own scansense
      window.addEventListener('keypress', (e)=>{
        if(this.scanBus.locked && this.scanBus.type=="return"){
          this.cancelClearScanStringTimeout()
          this.clearScanStringTimeout()
          if(this.keyShortcutMode){
            this.cancelClearScanStringTimeout()
            if(e.key==='/'){
              this.endShortcut()
            }else{
              if(e.key==='Enter'){
                console.log(this.scanString)
                this.handleShortcut(this.scanString)
              }else{
                if(!this.scanString) this.scanString = ""
                this.scanString = this.scanString + e.key
              }
            }
          }else{
            if(e.key==='/'){
              if(!this.scanString){
                this.cancelClearScanStringTimeout()
                this.keyShortcutMode = true
              }else{
                this.scanString = this.scanString + e.key
              }
            }else{
              if(e.key==='Enter'){
                let validatedType = scanSystem.validateType(this.scanString)
                if(validatedType){
                  this.scanInProgress = true
                  this.handleScan(this.scanBus.type)
                  this.clearScanString()
                  this.setScanBus('return')//important for this return specific thing
                }else{
                  this.clearScanString()
                  this.resetScanBus()
                  this.setScanBus('return')
                }
              }else{
                this.scanInProgress = false
                if(!this.scanString) this.scanString = ""
                this.scanString = this.scanString + e.key
              }
            }
          }
        }
      })
    }
    finally {
      this.initialLoader = false;
      console.log("Done Mounting")
    }
  },
  computed: {
    helpers() {
      return helpers
    },
    ...mapGetters(['getId', 'getEndpoint', "lookupBranch", "isAllowed", 'isManaged', 'lookupUsername', 'scanBus', 'serialNaming', 'getGlobalValue', 'getBranch', 'getBranches', 'getBranchData']),
    modifyDisabledCriteria(){
      if(this.dreturn)
        return parseInt(this.dreturn.status) !== 0
      return 0
    },
    isSealable(){
      console.log(this.dreturn)
    return false
    },
    computedSubtotal(){
      return this.dreturn?.ReturnLineItems ? utils.pff2(this.dreturn.ReturnLineItems.reduce((acc,x)=>acc+(utils.pff2(x.returnValue)*utils.pff(x.quantity)),0)):0
    },
  },
  methods: {
    ...mapMutations([
      'setScanBus',
      'resetScanBus',
      'updateCurrentRegister'
    ]),
    getOrderLineItemSerials(li){
      return this.selectedOrder.OrderLineItems.find(x => x.productId===li.productId)?.serials||[]
    },
    cancelRedeemConfirm(){
      this.paymentToConfirmType = "";
      this.confirmRedeemDialog.isOpen = false;
    },
    confirmRedeem(){
      this.confirmRedeemDialog.bypass = true;
      this.redeemCNForCashConfirmed(this.confirmRedeemCredentials)

      this.cancelRedeemConfirm()
    },
    async redeemCNForCash(type){
      try{
        this.confirmRedeemLoading = true;

        if(this.getGlobalValue('registerModuleEnabled')!=='true'){
          await this.redeemCNForCashConfirmed(type)
          return;
        }
        this.confirmRedeemCredentials = type;

        let res = await axios.get(`${this.getEndpoint}/api/registers/checkPaymentBypass`)
        if(!res.data.data.prompt){
          await this.redeemCNForCashConfirmed(type)
          return;
        }
        this.confirmRedeemDialog.isOpen = true;
      }
      finally {
        this.confirmRedeemLoading = false
      }
    },
    async redeemCNForCashConfirmed(obj){
      try{
        this.cnRedeemLoader = true;

        await axios.post(`${this.getEndpoint}/api/creditNotes/cashRedeem/${this.dreturn.CreditNote.id}`, obj)
        this.$snack("✅ Success.")
        this.dreturn.CreditNote.status = 2;
      }
      finally{
        this.cnRedeemLoader = false;
      }
    },
    async printCN(id){
      try {
        this.printCNLoader = true
        let x = await axios.post(`${this.getEndpoint}/api/custom/print/creditnote/${id}`)

        if(this.getGlobalValue('useESCPOSPrintForAndroid')==="true" && utils.getMobileOperatingSystem()==="Android"){
          let escposAppLink = this.getGlobalValue('ESCPOSDefaultAppLink') || `print://escpos.org/escpos/[type]/print?srcTp=uri&srcObj=html&numCopies=1&openCashDrawer=0&src='data:text/html,`

          if(this.getUser.metadata.preferredESCPOSAppLink || escposAppLink.includes('[type]')){
            let defAppLink = escposAppLink.includes('[type]')?escposAppLink:`print://escpos.org/escpos/[type]/print?srcTp=uri&srcObj=html&numCopies=1&openCashDrawer=0&src='data:text/html,`
            escposAppLink = defAppLink.replace('[type]', this.getUser.metadata.preferredESCPOSAppLink || 'usb')
          }

          let dynHtml = `${escposAppLink}${encodeURIComponent(x.data.data.job.htmlToPrint)}'`;
          window.location.href = dynHtml;
        }else if(utils.getMobileOperatingSystem()==='iOS'){
          let newWindow = window.open("", "__blank")
          newWindow.document.open()
          newWindow.document.write(x.data.data.job.htmlToPrint)
          newWindow.document.close()
          newWindow.onload = function () {
            newWindow.print(); // Open print dialog
            setTimeout(() => newWindow.close(), 1000); // Auto-close after printing
          }
        }else{
          const ifrm = document.createElement('iframe');
          ifrm.style.display = "none"; // Hide the iframe
          document.body.appendChild(ifrm);

          const iframeDoc = ifrm.contentDocument || ifrm.contentWindow.document;
          iframeDoc.open();
          iframeDoc.write(x.data.data.job.htmlToPrint); // Write the fabricated HTML content
          iframeDoc.close();

          // Wait for the content to load and then print
          ifrm.onload = function () {
            ifrm.contentWindow.print(); // Trigger the print
            window.addEventListener("afterprint", () => {
              document.body.removeChild(ifrm); // Clean up the iframe after printing
            });
          };
        }
      } finally {
        this.printCNLoader = false
      }
    },
    parseStatus(id){
      if(id===-1) return "Voided"
      else if(id===0) return "Draft"
      else if(id===1) return "Sealed"
    },
    isMultiples(item){
      if(item.metadata?.quantities?.length>0){
        return item.metadata?.multipleAmount!=null && item.metadata.quantities.some(x => x.qtyOfMultiple!=null)
      }
      return item.metadata?.qtyOfMultiple!=null && item.metadata?.multipleAmount!=null
    },
    countLineItemsForProduct(productId){
      return this.dreturn.ReturnLineItems.filter(x => x.productId === productId).length
    },
    multipleLabel(item){
      return utils.multipleLabelOf(item.metadata, item.Product?.metadata)
    },
    // Quantities of a "used in multiples" line, with how they break down: "546in [6 x 7ft 7in]". qty is the total in the line's own unit.
    // meta/conv default to the line's own; the returned lines pass their source order line's conversion.
    qtyText(item, qty, meta = null, conv = null){
      meta = meta || item.metadata || {};
      conv = conv || meta.conversion || null;
      let q = utils.pff(qty || 0, conv ? 12 : undefined);
      let base = conv ? `${q}${conv.unit}` : `${q}`;
      let amount = parseFloat(meta.multipleAmount);
      if(!(meta.qtyOfMultiple != null || meta.quantities?.some(x => x.qtyOfMultiple != null)) || !amount || !(q > 0)) return base;
      let units = q / amount;
      if(Math.abs(units - Math.round(units)) > 1e-6) return base; // not a whole number of this length, so there is no clean "n x length"
      let per = conv ? utils.conversionBreakdown(conv, amount) : `${utils.pff(amount, 6)}${utils.multipleLabelOf(meta, item.Product?.metadata)}`;
      return `${base} [${Math.round(units)} × ${per}]`;
    },
    // Same as qtyText, split so only the QTY count can be shown in bold.
    qtyParts(item, qty, meta = null, conv = null){
      meta = meta || item.metadata || {};
      conv = conv || meta.conversion || null;
      let q = utils.pff(qty || 0, conv ? 12 : undefined);
      let base = conv ? `${q}${conv.unit}` : `${q}`;
      let isMult = meta.qtyOfMultiple != null || !!meta.quantities?.some(x => x.qtyOfMultiple != null);
      if(!isMult) return {prefix: '', count: base, suffix: ''}; // a plain QTY: the number is the QTY
      let amount = parseFloat(meta.multipleAmount);
      if(!amount || !(q > 0)) return {prefix: base, count: null, suffix: ''};
      let units = q / amount;
      if(Math.abs(units - Math.round(units)) > 1e-6) return {prefix: base, count: null, suffix: ''};
      let per = conv ? utils.conversionBreakdown(conv, amount) : `${utils.pff(amount, 6)}${utils.multipleLabelOf(meta, item.Product?.metadata)}`;
      return {prefix: `${base} [`, count: String(Math.round(units)), suffix: ` × ${per}]`};
    },
    returnLineParts(returnLine){
      let src = this.sourceOrderLine(returnLine);
      return this.qtyParts(returnLine, returnLine.quantity, returnLine.metadata, src?.metadata?.conversion || null);
    },
    partsText(parts){
      return `${parts.prefix || ''}${parts.count ?? ''}${parts.suffix || ''}`;
    },
    // set when a returned line asks for more than is left to return on its order line (ordered - already returned)
    overReturn(returnLine){
      // only a draft can be over: once sealed (or voided) its own quantity is already counted in the order's "already returned"
      if(this.dreturn.status !== 0) return null;
      let src = this.sourceOrderLine(returnLine);
      if(!src) return null;
      let prec = src.metadata?.conversion ? 12 : undefined;
      let balance = this.remainingBalance(src);
      let qty = utils.pff(returnLine.quantity || 0, prec);
      return qty > balance + 1e-9 ? {balance} : null;
    },
    sourceOrderLine(returnLine){
      return this.selectedOrder?.OrderLineItems?.find(x => x.id === returnLine.metadata?.orderLineItemId) || null;
    },
    returnLineQtyText(returnLine){
      let src = this.sourceOrderLine(returnLine);
      return this.qtyText(returnLine, returnLine.quantity, returnLine.metadata, src?.metadata?.conversion || null);
    },
    // what is still left to return on an order line: ordered - already returned
    remainingBalance(item){
      let prec = item.metadata?.conversion ? 12 : undefined;
      return Math.max(0, utils.pff(utils.pff(item.quantity, prec) - utils.pff(item.returnedQt || 0, prec), prec));
    },
    // the remaining-balance button only needs a balance left (an existing draft line for it is simply set to the balance)
    existingReturnLineFor(item){
      return this.dreturn.ReturnLineItems?.find(x => x.metadata?.orderLineItemId === item.id) || null;
    },
    // the line in this return already carries exactly the balance, so adding it again would change nothing
    returnLineAlreadyAtBalance(item){
      let line = this.existingReturnLineFor(item);
      if(!line) return false;
      let prec = item.metadata?.conversion ? 12 : undefined;
      return Math.abs(utils.pff(line.quantity || 0, prec) - this.remainingBalance(item)) < 1e-9;
    },
    addRemainingDisabled(item){
      return this.modifyDisabledCriteria || !(this.remainingBalance(item) > 0) || this.returnLineAlreadyAtBalance(item);
    },
    addRemainingTooltip(item){
      if(!(this.remainingBalance(item) > 0)) return 'Nothing left to return';
      let text = this.partsText(this.qtyParts(item, this.remainingBalance(item)));
      return this.returnLineAlreadyAtBalance(item) ? `Already returning the full balance (${text})` : `Add the remaining balance (${text})`;
    },
    addReturnLineItemDisabled(item){
      if(this.modifyDisabledCriteria)
        return true
      if(this.dreturn.ReturnLineItems.filter(x=>x.metadata?.orderLineItemId===item.id).length>1)
        return true
      if(utils.pff(item.quantity) <= utils.pff(item.returnedQt))
        return true
      return false
    },
    resetSearchCustomerDialog(){
      this.customer = {}
      this.searchCustomerDialog.term = ''
      this.searchCustomerDialog.results = []
      this.searchCustomerDialog.loader = false
    },
    openSearchCustomerDialog(){
      this.searchCustomerDialog.isOpen = true
    },
    closeSearchCustomerDialog(){
      this.resetSearchCustomerDialog()
      this.searchCustomerDialog.isOpen = false
    },
    async findCustomerByPhone(){
      try {
        if(!this.customer?.phone){
          this.customer.suggestedMatches = []
          return
        }
        if(this.customer?.phone?.length < 3) return
        this.findCustomerByPhoneLoader = true
        let res = await axios.get(`${this.getEndpoint}/api/customers/byPhone/${this.customer.phone}`)
        this.customer.suggestedMatches = res.data.data
        this.findCustomerByPhoneLoader = false
      } catch (error) {
        console.error(error)
        this.$snack(error.msg || error, "error")
        this.findCustomerByPhoneLoader = false
      }
    },
    async findCustomerByName(){
      try {
        if(!this.customer?.name){
          this.customer.suggestedMatches = []
          return
        }
        if(this.customer?.name?.length < 3) return
        this.findCustomerByNameLoader = true
        let res = await axios.get(`${this.getEndpoint}/api/customers/byName/${this.customer.name}`)
        this.customer.suggestedMatches = res.data.data
        this.findCustomerByNameLoader = false
      } catch (error) {
        console.error(error)
        this.$snack(error.msg || error, "error")
        this.findCustomerByNameLoader = false
      }
    },
    async updateReturn(customValue=null){
      try {
        if(this.modifyDisabledCriteria) return // very important it must be at the top
        if(this.initialLoader) return false
        if(this.dreturn && this.dreturn.status > 0){
          throw "❌ Return already Sealed."
        }
        this.updateStateValue = 0
        if(!customValue) this.dreturn.totalValue = this.computedSubtotal||0
        await axios.put(`${this.getEndpoint}/api/returns/${this.$route.params.id}`, this.dreturn)
        console.log("Update Request sent out.")
        this.updateStateValue = 1
        this.returnOk()
      } catch (error) {
        this.updateStateValue = 2
        console.error(error)
        this.$snack(error.msg || error, "error")
      } finally {
        this.loader = false
      }
    },
    clearScanString(){
      this.scanString = ''
      this.scanInProgress = false
      console.log("🔁 Scan String Cleared")
    },
    clearScanStringTimeout(){
      this.timeout = setTimeout(this.clearScanString,500)
    },
    cancelClearScanStringTimeout(){
      clearTimeout(this.timeout)
    },
    async handleScan(type){
      try {
        let s = this.scanString.replace(/\\\/\/\\=/,'')
        let pId = (s.replace(`${type}-`, ''));
        let p;
        pId
        let prod = null
        switch(type){
          case 'INV':
            console.log("Return Invoice Scanned: ", s)
            this.handleScannedInvoice(s.split("-")[1])
            this.scanInProgress = false
            break
          case 'VSID':
            // this.setScanBus({username: this.lookupUsername(pId.split("-")[0]), uId: pId.split("-")[0]})
            // console.log(this.lookupUsername(pId.split("-")[0]))
            p = '/users/view/'+pId.split("-")[0]
            if(this.$route.path!==p)
              await this.$router.push({path: p})
            this.scanInProgress = false
            break
          case 'JT':
            console.log("Job Ticket Scanned: ", s)
            p = `/orders/view/${s.split('-')[1]}`
            if(this.$route.path!==p)
              await this.$router.push({path: p})
            this.scanInProgress = false
            break
          case 'DN':
            console.log("Delivery Note Scanned: ", s)
            p = `/deliveries/view/${s.split('-')[1]}`
            if(this.$route.path!==p)
              await this.$router.push({path: p})
            this.scanInProgress = false
            break
          case 'PL':
            console.log("Product Scanned: ", s) //this
            this.openProductScanDialog()
            prod = await this.lookupProduct((s.split('-')[1]), "ID")
            if(!prod) throw "Product Not In VIMS DB."
            this.productScanDialog.item = prod.data
            this.scanInProgress = false
            break
          case 'EXT':
            console.log("Invoice External Product Scanned: ", s)
            this.openProductScanDialog()
            prod = await this.lookupProduct(s, "SKU")
            if(!prod) throw "External Product Not In VIMS DB."
            this.productScanDialog.item = prod
            this.scanInProgress = false
            break
        }
      } catch (error) {
        console.log(error)
        this.scanInProgress = false
        this.$snack(error)
      }
    },
    openProductScanDialog(){
      this.productScanDialog.isOpen = true
      this.productScanDialog.loader = true
    },
    closeProductScanDialog(){
      this.productScanDialog.isOpen = false,
      this.productScanDialog.loader = false
      this.productScanDialog.item = ''
    },
    async lookupProduct(s, type){
      try {
        let res;
        if(type === "SKU")
          res = await axios.get(`${this.getEndpoint}/api/products/bySKU/${s}`)
        if(type === "ID")
          res = await axios.get(`${this.getEndpoint}/api/products/${s}`)
        if(!res.data.data) throw 'External barcode is not in DB.'
        return res.data.data
      } catch (error) {
        if(error.customError){
          console.error(error)
          this.$snack('External barcode is not in DB.')
        }
        else this.$snack(error)
      } finally {
        this.productScanDialog.loader = false
      }
    },
    async handleScannedInvoice(id){
      let res = await axios.get(`${this.getEndpoint}/api/orders/forReturns/${id}`)
      let data = res.data.data
      if(!data) throw "Invoice needs to be sealed."
      if(this.dreturn.customerId){
         if(data.Customer.id !== this.dreturn.customerId) throw "Invoice does not belong to the selected customer."
      }else{
        this.setCustomer(data.Customer)
      }
      await this.loadOrder(id, data)
    },
    purchaseTableRowClick(row){
      this.loadOrder(row.id)
    },
    async loadOrder(id){
      try {
        let res = await axios.get(`${this.getEndpoint}/api/orders/forReturns/${id}`)
        this.selectedOrder = res.data.data;
        for(let i of this.selectedOrder.Returns){
          for(let j of i.ReturnLineItems){
            let q = (j.metadata?.orderLineItemId && this.selectedOrder.OrderLineItems.find(x=>x.id===j.metadata.orderLineItemId)) || this.selectedOrder.OrderLineItems.find(x=>x.productId==j.productId)
            if(!q) continue;
            if(!q.returnedQt) q.returnedQt = 0
            q.returnedQt += utils.pff(j.quantity)
          }
        }

        this.dreturn.orderId = this.selectedOrder.id
        await this.updateReturn()
        this.returnOk()
      } catch (error) {
        console.log(error)
        this.$snack(error.msg)
        this.directOrderSearch.value = this.dreturn.orderId
      }
    },
    async removeReturnLineItem(e){
      await axios.delete(`${this.getEndpoint}/api/returns/lineItem/${e}`)
      let i = (this.dreturn.ReturnLineItems.findIndex(x=>x.id===e))
      if(i == -1) throw "Item Could Not Be Found. Refresh this page."
      this.dreturn.ReturnLineItems.splice(i,1)
      this.dreturn.totalValue = this.computedSubtotal
      if(!this.dreturn.ReturnLineItems) this.dreturn.ReturnLineItems = []
      await this.updateReturn()
      this.returnOk()
    },
    async addReturnLineItem(p, remaining = false){
      try {
        this.updateStateValue = 0
        // let res = await axios.get(`${this.getEndpoint}/api/returns/addItemPrecheck/${this.dreturn.customerId}/${p.productId}`)
        // if(!res.data) throw "Could not add item."
        // console.log("Precheck done")
        p.loading = true

        // A return line item is always tied 1:1 to the order line item it's being returned
        // against — there's no "add another" beyond what was actually ordered on this line.
        let found = this.dreturn.ReturnLineItems.find(x => x.metadata?.orderLineItemId === p.id) || null;

        if(found && remaining){
          let balance = this.remainingBalance(p);
          let amount = parseFloat(found.metadata.multipleAmount ?? p.metadata.multipleAmount);
          if(this.isMultiples(found)){
            let units = utils.pff(balance / amount, 6);
            if(Math.abs(units - Math.round(units)) > 1e-6) throw `The remaining ${balance} is not a whole number of ${amount}.`;
            if(found.metadata.quantities?.length > 0){
              for(let loc of found.metadata.quantities) loc.qtyOfMultiple = 0;
              let target = found.metadata.quantities.find(x => x.qtyOfMultiple != null) || found.metadata.quantities[0];
              target.qtyOfMultiple = Math.round(units);
            } else {
              found.metadata.qtyOfMultiple = Math.round(units);
            }
          } else if(found.metadata.quantities?.length > 0){
            for(let loc of found.metadata.quantities) loc.quantity = 0;
            found.metadata.quantities[0].quantity = balance;
          } else {
            found.quantity = balance;
          }
          await this.updateReturnLineItem(found)
          this.updateStateValue = 1
          return;
        }

        if(found){
          if(this.isMultiples(found)){
            if(found.metadata.quantities?.length > 0){
              let fBranch = found.metadata.quantities.find(x => utils.pff(x.qtyOfMultiple) > 0);
              if(fBranch) fBranch.qtyOfMultiple = utils.pff((fBranch.qtyOfMultiple || 0) + 1);
            } else {
              found.metadata.qtyOfMultiple = utils.pff((found.metadata.qtyOfMultiple || 0) + 1);
            }
          } else {
            if(found.metadata.quantities?.length > 0){
              let fBranch = found.metadata.quantities.find(x => utils.pff(x.quantity) > 0);
              if(fBranch) fBranch.quantity += utils.pff(p.metadata.quantityStepAmount || 1);
            } else {
              found.quantity = utils.pff(utils.pff(found.quantity) + utils.pff(p.metadata.quantityStepAmount || 1));
            }
          }
          await this.updateReturnLineItem(found)
          this.updateStateValue = 1
          return;
        }

        let isMultiples = this.isMultiples(p);
        let tempLineItem = {
          returnId: this.$route.params.id,
          productId: p.productId,
          orderId: p.orderId,
          serial: '',
          returnValue: helpers.pff2(p.metadata.lineTotal/p.quantity),
          isReplacement: false,
          addedToInventory: true,
          notes: '',
          quantity: utils.pff(p.metadata.minSaleQuantity||1),
          metadata: {
            minSaleQuantity: utils.pff(p.metadata.minSaleQuantity||1),
            orderLineItemId: p.id
          },
          Product: {
            name: p.productName
          },
          orderSerials: p.serials||[]
        }

        if(isMultiples){
          tempLineItem.metadata.usedInMultiples = true
          tempLineItem.metadata.multipleLabel = p.metadata.multipleLabel || ''
          // Mirrored from the source order line item's own snapshot, not the product's current live
          // flag - a return must always follow whatever rule was in effect when the order was made.
          tempLineItem.metadata.lockMultipleAmount = p.metadata.lockMultipleAmount !== false
          tempLineItem.metadata.qtyOfMultiple = 1
          tempLineItem.metadata.multipleAmount = p.metadata.multipleAmount
          tempLineItem.quantity = utils.computeMultipleQuantity(tempLineItem.metadata.qtyOfMultiple, tempLineItem.metadata.multipleAmount)
        }

        if(this.getGlobalValue('VEC_ALLOW_WAREHOUSE_INVENTORY_PULLING')==='true'){
          tempLineItem.metadata.quantities = []

          // this.warehouses can have the current branch filtered out (removeFromQuantityFields),
          // so the current branch is only used as a seed location when it's actually in the list.
          // Prefer a location the source order line item actually holds quantity at - that's where
          // stock was really pulled from, and it's the only place guaranteed to carry a usable
          // multipleAmount for the qtyOfMultiple x multipleAmount computation below. Falling back to
          // the first listed warehouse (rather than leaving every location at 0) guarantees the
          // seeded default always lands somewhere.
          let sourceLocWithQty = w => p.metadata?.quantities?.find(x => x.locationId===w.id && utils.pff(x.quantity)>0);
          let seedLocationId = (
              this.warehouses.find(w => w.id===this.getBranch && sourceLocWithQty(w))
              || this.warehouses.find(sourceLocWithQty)
              || this.warehouses.find(w => w.id===this.getBranch)
              || this.warehouses[0]
          )?.id;

          // A warehouse-pulling multiples line item shares ONE multiple value across every
          // location - mirrored from the source order line item's own shared value, falling back
          // to the product's quantity step so it can never resolve to 0/undefined.
          if(isMultiples) tempLineItem.metadata.multipleAmount = p.metadata.multipleAmount ?? p.metadata.quantityStepAmount ?? 1;

          for(let warehouse of this.warehouses){
            if(isMultiples){
              let qom = (warehouse.id===seedLocationId)?1:0;
              tempLineItem.metadata.quantities.push({locationId: warehouse.id, qtyOfMultiple: qom, quantity: utils.computeMultipleQuantity(qom, tempLineItem.metadata.multipleAmount)})
            } else {
              tempLineItem.metadata.quantities.push({locationId: warehouse.id, quantity: (warehouse.id===seedLocationId)?utils.pff(p.metadata.minSaleQuantity||1):0})
            }
          }
          if(isMultiples) delete tempLineItem.metadata.qtyOfMultiple;
          tempLineItem.quantity = utils.pff(tempLineItem.metadata.quantities.reduce((a, c) => a+utils.pff(c.quantity), 0));
        }

        if(remaining){
          // the whole balance (ordered - returned) instead of the default single unit
          let balance = this.remainingBalance(p);
          if(!(balance > 0)) throw "There is nothing left to return on this line.";
          let multiplePrecision = p.metadata?.conversion ? 12 : undefined;
          if(isMultiples){
            let amount = parseFloat(tempLineItem.metadata.multipleAmount);
            let units = utils.pff(balance / amount, 6);
            if(!amount || Math.abs(units - Math.round(units)) > 1e-6) throw `The remaining ${balance} is not a whole number of ${amount}, so it cannot be added in one go. Add the line and set the quantity.`;
            units = Math.round(units);
            if(tempLineItem.metadata.quantities?.length > 0){
              let seed = tempLineItem.metadata.quantities.find(x => x.qtyOfMultiple > 0) || tempLineItem.metadata.quantities[0];
              for(let loc of tempLineItem.metadata.quantities){
                loc.qtyOfMultiple = loc === seed ? units : 0;
                loc.quantity = utils.computeMultipleQuantity(loc.qtyOfMultiple, amount, multiplePrecision);
              }
              tempLineItem.quantity = utils.pff(tempLineItem.metadata.quantities.reduce((a, c) => a + utils.pff(c.quantity, multiplePrecision), 0), multiplePrecision);
            } else {
              tempLineItem.metadata.qtyOfMultiple = units;
              tempLineItem.quantity = utils.computeMultipleQuantity(units, amount, multiplePrecision);
            }
          } else if(tempLineItem.metadata.quantities?.length > 0){
            let seed = tempLineItem.metadata.quantities.find(x => utils.pff(x.quantity) > 0) || tempLineItem.metadata.quantities[0];
            for(let loc of tempLineItem.metadata.quantities) loc.quantity = loc === seed ? balance : 0;
            tempLineItem.quantity = balance;
          } else {
            tempLineItem.quantity = balance;
          }
        }

        let res = await axios.post(`${this.getEndpoint}/api/returns/lineItem/${this.dreturn.id}`, tempLineItem)
        this.dreturn?.ReturnLineItems.push(res.data.data)
        this.dreturn.totalValue = parseFloat(this.computedSubtotal)
        this.updateStateValue = 1
        await this.updateReturn()
        this.returnOk()
      } catch (error) {
        console.log(error)
        this.$snack(error)
        this.updateStateValue = 2
      } finally {
        p.loading = false
        this.$forceUpdate()
      }
    },
    async updateReturnLineItem(p){
      try {
        this.updateStateValue = 0

        // warn before sending: the quantity entered is worked out from QTY x multiple below, so check it after that

        if(p.metadata.quantities?.length>0){
          if(p.metadata.multipleAmount!=null) p.metadata.multipleAmount = utils.pff(p.metadata.multipleAmount||0);
          for(let loc of p.metadata.quantities){
            if(loc.qtyOfMultiple!=null && p.metadata.multipleAmount!=null){
              loc.qtyOfMultiple = utils.pff(loc.qtyOfMultiple||0);
              loc.quantity = utils.computeMultipleQuantity(loc.qtyOfMultiple, p.metadata.multipleAmount);
            }
          }
          p.quantity = utils.pff(p.metadata.quantities.reduce((a, c) => a+utils.pff(c.quantity), 0));
        } else if(p.metadata.qtyOfMultiple!=null && p.metadata.multipleAmount!=null){
          p.metadata.qtyOfMultiple = utils.pff(p.metadata.qtyOfMultiple||0);
          p.metadata.multipleAmount = utils.pff(p.metadata.multipleAmount||0);
          p.quantity = utils.computeMultipleQuantity(p.metadata.qtyOfMultiple, p.metadata.multipleAmount);
        }

        let over = this.overReturn(p);
        if(over){
          let src = this.sourceOrderLine(p);
          this.$snack(`The amount being returned (${this.partsText(this.returnLineParts(p))}) is more than what was ordered - only ${this.partsText(this.qtyParts(src, over.balance))} is left to return.`, "error")
        }

        let res = await axios.put(`${this.getEndpoint}/api/returns/lineItem/${p.id}`, p)
        if(!res.data.success) this.$snack(`Quantity invalid for item ${p.productId}. Resetting to previous quantity of ${utils.pff(res.data.data.quantity)}.`)
        let ix = this.dreturn.ReturnLineItems.findIndex(x=>x.id==p.id)
        ix==-1?null:this.dreturn.ReturnLineItems.splice(ix, 1, res.data.data)
        this.updateStateValue = 1
        this.dreturn.totalValue = parseFloat(this.computedSubtotal)
        await this.updateReturn()
        this.returnOk()
      } catch (error) {
        console.log(error)
        this.$snack(error.msg)
        this.updateStateValue = 2
        p.quantity = utils.pff(p.metadata.minSaleQuantity||1);
      }
    },
    async attemptSeal(val){
      try {
        this.sealLoader = true
        let res = await axios.put(`${this.getEndpoint}/api/returns/sign/${this.dreturn.id}`, {...val, return: this.dreturn})
        this.$snack(`✅ Return sealed. Created CN # ${res.data.data.cn.id} for this return.`)
        this.dreturn.sealedAt = res.data.data.sealedAt
        this.dreturn.sealedBy = res.data.data.sealedBy
        this.dreturn.status = 1
        this.dreturn.CreditNote = res.data.data.cn
      } finally{
        this.sealLoader = false
      }
    },
    async voidReturn(val){
      try {
        this.voidLoader = true
        await axios.put(`${this.getEndpoint}/api/returns/void/${this.dreturn.id}`, val)
        this.$snack("Return voided.")
        // stock, serials and the credit note all changed, so load the page again
        setTimeout(() => window.location.reload(), 800)
      } finally{
        this.voidLoader = false
      }
    },
    async unvoidReturn(val){
      try {
        this.voidLoader = true
        await axios.put(`${this.getEndpoint}/api/returns/unvoid/${this.dreturn.id}`, val)
        this.$snack("Return unvoided.")
        setTimeout(() => window.location.reload(), 800)
      } finally{
        this.voidLoader = false
      }
    },
    returnOk(){
      if(this.dreturn?.status == 0){ // return is a draft
        console.log(this.dreturn)
        if(!this.dreturn.orderId){
          console.log("!this.dreturn.orderId")
          return false
        }
        if(this.dreturn.totalValue===null){
          console.log("!this.dreturn.totalValue")
          return false
        }
        if(!this.dreturn.ReturnLineItems){
          console.log("!this.dreturn.ReturnLineItems")
          return false
        }
        if(this.dreturn.ReturnLineItems.length < 1){
          console.log("this.dreturn.ReturnLineItems.length < 1")
          return false
        }

        for(let rli of this.dreturn.ReturnLineItems){
          if(rli.Product?.metadata?.requireSerials){
            if(utils.pff(rli.quantity)!=(rli.serials?.length||0)) return false;
          }
          if(utils.pff(rli.quantity)<(rli.serials?.length||0)) return false
        }

        console.log("Return ok final.")
        return true
      }
      console.log("Return not ok final.")
      return false
    },
    openLineItemSerialsDialog(item){
      this.lineItemSerialsDialog.data = item;
      this.lineItemSerialsDialog.isOpen = true;
      this.lineItemSerialsDialog.other = null;
      this.lineItemSerialsDialog.search = "";
      this.lineItemSerialsDialog.newSerial = ""
      this.lineItemSerialsDialog.filtered = item.serials?[...item.serials]:[]
    },
    closeLineItemSerialsDialog(){
      this.lineItemSerialsDialog.isOpen = false;
      this.lineItemSerialsDialog.data = null;
      this.lineItemSerialsDialog.other = null;
      this.lineItemSerialsDialog.search = "";
      this.lineItemSerialsDialog.newSerial = ""
      this.lineItemSerialsDialog.filtered = []
    },
    async getLineSerials(){
      if(!this.lineItemSerialsDialog.data) return;

      let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.lineItemSerialsDialog.data.returnId}/lineSerials/${this.lineItemSerialsDialog.data.productId}`)
      this.lineItemSerialsDialog.data.serials = res.data.data

      this.filterLineItemSerials();
    },
    async addOrderSerial(serial, dialog, addFunction){
      if(!serial || !serial.serial) return;
      dialog.newSerial = serial.serial;

      await addFunction()
    },
    async addLineItemSerial(){
      try{
        this.lineItemSerialsDialog.isLoading = true;

        let item = this.lineItemSerialsDialog.data

        if(!this.lineItemSerialsDialog.newSerial?.trim()){
          throw `Serial cannot be empty.`
        }

        if(item.serials?.length>=utils.pff(item.quantity)){
          throw `Max number of ${this.serialNaming.pluralLower} for this line item.`
        }

        await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/${item.returnId}/serials`, {productId: item.productId, serial: this.lineItemSerialsDialog.newSerial.trim()})

        await this.getLineSerials();

        this.lineItemSerialsDialog.newSerial = ""
      }
      finally {
        this.lineItemSerialsDialog.isLoading = false;
      }
    },
    async removeLineItemSerial(serial, dialog){
      try{
        dialog.isLoading = true;

        let item = dialog.data;

        await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.dreturn.id}/returnSerials`, {productId: item.productId, serialId: serial})

        await this.getLineSerials();
        await this.getWarehouseLineSerials();

        this.$forceUpdate()
      }
      finally {
        dialog.isLoading = false;
      }
    },
    filterLineItemSerials(){
      if(!this.lineItemSerialsDialog.data) return;

      if(!this.lineItemSerialsDialog.search){
        this.lineItemSerialsDialog.filtered = [...this.lineItemSerialsDialog.data.serials]
        return
      }

      this.lineItemSerialsDialog.filtered = this.lineItemSerialsDialog.data.serials.filter(x => x.serial.toLowerCase().includes(this.lineItemSerialsDialog.search.toLowerCase()))

      this.$forceUpdate();
    },
    async openWarehouseLineItemSerialsDialog(item, loc){
      try{
        this.warehouseLineItemSerialsDialog.isLoading = true;
        this.warehouseLineItemSerialsDialog.data = item;
        this.warehouseLineItemSerialsDialog.location = loc.locationId;

        this.warehouseLineItemSerialsDialog.filtered = item.serials?[...item.serials]:[];

        this.warehouseLineItemSerialsDialog.isOpen = true;
        this.warehouseLineItemSerialsDialog.other = null;
        this.warehouseLineItemSerialsDialog.search = "";
        this.warehouseLineItemSerialsDialog.newSerial = ""

        this.$forceUpdate()
      }
      finally {
        this.warehouseLineItemSerialsDialog.isLoading = false;
      }
    },
    closeWarehouseLineItemSerialsDialog(){
      this.warehouseLineItemSerialsDialog.isOpen = false;
      this.warehouseLineItemSerialsDialog.data = null;
      this.warehouseLineItemSerialsDialog.location = null;
      this.warehouseLineItemSerialsDialog.other = null;
      this.warehouseLineItemSerialsDialog.search = "";
      this.warehouseLineItemSerialsDialog.newSerial = ""
      this.warehouseLineItemSerialsDialog.filtered = []
    },
    async getWarehouseLineSerials(){
      if(!this.warehouseLineItemSerialsDialog.data) return;

      let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/${this.dreturn.id}/getReturnLineSerials`, {productId: this.warehouseLineItemSerialsDialog.data.productId})

      this.warehouseLineItemSerialsDialog.data.serials = res.data.data.ProductSerials || []

      this.filterWarehouseLineItemSerials();
    },
    async addWarehouseLineItemSerial(){
      try{
        this.warehouseLineItemSerialsDialog.isLoading = true;

        let item = this.warehouseLineItemSerialsDialog.data

        console.log("wg", this.warehouseLineItemSerialsDialog)

        if(!this.warehouseLineItemSerialsDialog.newSerial?.trim()){
          throw `Serial cannot be empty.`
        }

        this.warehouseLineItemSerialsDialog.newSerial.replace("\\//\\=", "")

        if(item.serials?.length>=utils.pff(item.quantity)){
          throw `Max number of ${this.serialNaming.pluralLower} for this line item.`
        }

        await axios.post(`${this.getEndpoint}/api/${this.pluralLower}/${this.dreturn.id}/returnWarehouseSerials`, {productId: item.productId, serial: this.warehouseLineItemSerialsDialog.newSerial.trim(), location: this.warehouseLineItemSerialsDialog.location})

        //let lix = this.dreturn.ReturnLineItems.findIndex(x=>x.productId === item.productId)
        //this.warehouseLineItemSerialsDialog.data = res.data.data.item

        //this.dreturn.ReturnLineItems.splice(lix,1,res.data.data.item)

        await this.getWarehouseLineSerials();

        this.$forceUpdate()

        this.warehouseLineItemSerialsDialog.newSerial = ""
      }
      finally {
        this.warehouseLineItemSerialsDialog.isLoading = false;
      }
    },
    filterWarehouseLineItemSerials(){
      if(!this.warehouseLineItemSerialsDialog.data) return;

      if(!this.warehouseLineItemSerialsDialog.search){
        this.warehouseLineItemSerialsDialog.filtered = [...this.warehouseLineItemSerialsDialog.data.serials]
        return
      }

      this.warehouseLineItemSerialsDialog.filtered = this.warehouseLineItemSerialsDialog.data.serials.filter(x => x.toLowerCase().includes(this.warehouseLineItemSerialsDialog.search.toLowerCase()))

      this.$forceUpdate();
    }
  }
}
</script>
